import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useAppSelector } from "@/hooks/useAppSelector";

interface TechnicalDataProps {
  expanded: string | boolean;
  handleChange: (
    id: string
  ) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
}

const TechnicalData: React.FC<TechnicalDataProps> = ({
  expanded,
  handleChange,
}) => {
  const { productDetail } = useAppSelector((state) => state.home);

  // Extract technical data safely
  const techData = productDetail?.products?.[0]?.descriptions || [];

  // Separate key-value pairs & features
  const keyValueData = techData?.filter(
    (item) => item?.key && !item?.key?.startsWith("Feature")
  );
  const featureData = techData?.filter(
    (item) => item?.key && item?.key?.startsWith("Feature")
  );

  // Ensure "Description" appears first (Case-insensitive and trimmed)
  const sortedKeyValueData = [
    ...keyValueData?.filter(
      (item) => item?.key?.trim()?.toLowerCase() === "description"
    ),
    ...keyValueData?.filter(
      (item) => item?.key?.trim()?.toLowerCase() !== "description"
    ),
  ];

  return (
    <Accordion
      expanded={expanded === "technical" || expanded === ""}
      onChange={() => handleChange("technical")}
      sx={{
        border: "1px solid #d9d9d9",
        borderRadius: "6px",
        boxShadow: "none",
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography fontWeight="bold" fontSize="15px">
          Technical Data
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box>
          {/* Key-Value Pairs */}
          {sortedKeyValueData?.length > 0 ? (
            sortedKeyValueData?.map((item, index) => (
              <Box key={index} mb={1} display="flex" alignItems="center">
                <Typography variant="body2" fontSize="18px" mr={1}>
                  •
                </Typography>
                <Typography variant="body2">
                  <strong>{item?.key}:</strong> {item?.value || "N/A"}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="gray">
              No technical data available.
            </Typography>
          )}

          {/* Features (Only Values) */}
          {featureData?.length > 0 && (
            <Box mt={2}>
              <Typography fontWeight="bold" fontSize="15px" mb={1}>
                Features:
              </Typography>
              {featureData?.map((item, index) => (
                <Box key={index} mb={1} display="flex" alignItems="center">
                  <Typography variant="body2" fontSize="18px" mr={1}>
                    •
                  </Typography>
                  <Typography variant="body2">
                    {item?.value || "N/A"}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default TechnicalData;
